module.exports = __webpack_public_path__ + "static/media/Susan Magsamen.cbd7d506.png";